import { Dropdown } from '@delmonicos/shared-design-system-react/src/components/dropdown/dropdown';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Toggle } from '@delmonicos/shared-design-system-react/src/components/toggle/toggle';
import { EmspUserTokenType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/enums/emsp-user-token-type.enum';
import { useCreateEmspUserOcpiTokenFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/emsp-users/create-emsp-user-ocpi-token.form-validation';
import { CreateEmspUserOcpiTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/emsp-users/create-emsp-user-ocpi-token.model';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const EmspBoEmspUserOcpiTokenCreateFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT ////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } = useFormContext<CreateEmspUserOcpiTokenModel>();

    const {
      type,
      language,
      isActivated,
      isRevoked,
      ocpiUid,
      ocpiContractId,
      themeId,
    } = useCreateEmspUserOcpiTokenFormValidation();

    // RENDER /////////////////////////////////////////////////////////////////

    return (
      <Stack direction="column" gap={GapEnum.M}>
        <Controller
          name="type"
          control={control}
          rules={type}
          render={({ field, fieldState: { error } }) => {
            return (
              <Dropdown
                label={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.type',
                )}
                placeholder={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.type',
                )}
                required={!!type.required}
                errorMessage={error?.message}
                {...field}
                value={field.value ?? ''}
                onChange={(value) => field.onChange(value ?? '')}>
                {Object.values(EmspUserTokenType).map((s) => (
                  <Dropdown.Option key={s} value={s}>
                    {s}
                  </Dropdown.Option>
                ))}
              </Dropdown>
            );
          }}
        />
        <Controller
          name="language"
          control={control}
          rules={language}
          render={({ field, fieldState: { error } }) => {
            return (
              <TextInput
                label={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.language',
                )}
                placeholder={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.language',
                )}
                required={!!language.required}
                errorMessage={error?.message}
                {...field}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value === '' ? '' : e.target.value)
                }
              />
            );
          }}
        />
        <Controller
          name="isActivated"
          control={control}
          rules={isActivated}
          render={({ field }) => {
            return (
              <Toggle
                label={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.is-activated',
                )}
                id="isActivated"
                checked={field.value}
                onChange={(v) => field.onChange(v)}
              />
            );
          }}
        />
        <Controller
          name="isRevoked"
          control={control}
          rules={isRevoked}
          render={({ field }) => {
            return (
              <Toggle
                label={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.is-revoked',
                )}
                id="isRevoked"
                checked={field.value}
                onChange={(v) => field.onChange(v)}
              />
            );
          }}
        />
        <Controller
          name="ocpiUid"
          control={control}
          rules={ocpiUid}
          render={({ field, fieldState: { error } }) => {
            return (
              <TextInput
                label={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.ocpi-uid',
                )}
                placeholder={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.ocpi-uid',
                )}
                required={!!ocpiUid.required}
                errorMessage={error?.message}
                {...field}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value === '' ? '' : e.target.value)
                }
              />
            );
          }}
        />
        <Controller
          name="ocpiContractId"
          control={control}
          rules={ocpiContractId}
          render={({ field, fieldState: { error } }) => {
            return (
              <TextInput
                label={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.ocpi-contract-id',
                )}
                placeholder={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.ocpi-contract-id',
                )}
                required={!!ocpiContractId.required}
                errorMessage={error?.message}
                {...field}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value === '' ? '' : e.target.value)
                }
              />
            );
          }}
        />
        <Controller
          name="themeId"
          control={control}
          rules={themeId}
          render={({ field, fieldState: { error } }) => {
            return (
              <TextInput
                label={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.theme-id',
                )}
                placeholder={t(
                  'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.theme-id',
                )}
                required={!!themeId.required}
                errorMessage={error?.message}
                {...field}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value === '' ? '' : e.target.value)
                }
              />
            );
          }}
        />
      </Stack>
    );
  };
